export default __webpack_public_path__ + "static/benedek_gagyi-195fd85a0f9eb5fdfead8cf6d98f935c.jpg";